import React from "react";
import { useNavigate } from "react-router-dom";
import BottomNavigation from "@/components/BottomNavigation";
import AccountSettings from "@/components/AccountSettings";
import { useTranslation } from "react-i18next";
import { ScreenHeader } from "@/components/redesign";

const AccountSettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSuccess = () => {
    // Navigate back to settings page after successful update
    navigate("/settings");
  };

  return (
    <div className="page-container bg-gray-50">
      <ScreenHeader
        title={t("account.account_info")}
        showBack={true}
        onBack={() => navigate("/settings")}
      />

      <main className="main-content">
        <div className="px-4 pb-6">
          <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
            <AccountSettings onSuccess={handleSuccess} />
          </div>
        </div>
      </main>

      <BottomNavigation />
    </div>
  );
};

export default AccountSettingsPage;
